const style = {
  main: {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  icon: {
    viewBox: '0 0 20 20',
    statisticsSx: {
      color: 'action.active',
    },
  },
} as const;

export default style;
